import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { Row, Col, Button } from 'reactstrap'
import api from '../../api/api'
import { formatDate, getPaginationInfo, processError } from '../../lib/lib'
import EventsMiniCard from '../../components/Events/EventsMiniCard.jsx'
import { Stack } from "phosphor-react"
import Cookies from 'universal-cookie'
import Skeleton from '../../components/UI/Skeleton'
const cookies = new Cookies()

class EventDesc extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            events: { rows: [] },
            page: 1,
            limit: 2,
            // eslint-disable-next-line no-undef
            imageUrl: process.env.REACT_APP_IMAGEURL,
            eventInfo: {
                data: [],
                content: '',
                image: '',
                title: '',
                desc: '',
            },
            eventsLoaded: false,
            eventsInfoLoaded: false,
            imageLoaded: false,
            dataLoaded: false,
        }
        this.routeToEvents = this.routeToEvents.bind(this)
    }

    getEventInfo(data) {
        return new Promise((resolve, reject) => {
            api.getEventInfo(data)
                .then((eventInfo) => resolve(eventInfo))
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    getEvents(data) {
        return new Promise((resolve, reject) => {
            api.getEvents(data)
                .then((res) => resolve(res))
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    componentWillMount() {
        const token = cookies.get('accessToken')
        const id = this.props.match.params.eventId
        const lang = this.props.i18n.language
        const { start, end } = getPaginationInfo({ page: this.state.page, limit: this.state.limit })
        let arrPromise = [
            this.getEvents({ start, end, lang, token, sort: 'start', order: 'DESC' }).then((events) => this.setState({ events, eventsLoaded: true })),
            this.getEventInfo({ id, lang, token }).then((eventInfo) => {
                eventInfo.data = eventInfo.data ? JSON.parse(eventInfo.data) : []
                this.setState({ eventInfo, eventsInfoLoaded: true })
            }),
        ]
        Promise.all(arrPromise).then(() => this.setState({ dataLoaded: true }))
    }

    routeToEvents() {
        this.props.history.push('/events')
    }

    setCookies() {
        return new Promise((resolve, reject) => {
            try {
                const items = cookies.get('order') || []
                items.push({
                    userId: cookies.get('userId'),
                    itemId: this.state.eventInfo.id,
                })
                cookies.set('order', items, { path: '/' })
                resolve(items)
            } catch (e) {
                reject(e)
            }
        })
    }

    addToCart(event) {
        event.preventDefault()
        this.setCookies().then(() => {
            this.props.history.push('/cart')
        })
    }

    render() {
        const { t } = this.props
        return (
            <div>
                <div className="content custom-bg position-relative">
                    <Row className="w-100 m-0">
                        <Col xs={12} md={12} className="p-0">
                            <div className="page-title">
                                <div className="float-left">
                                    {
                                        this.state.eventsInfoLoaded ?
                                            <h1 className="title event-dashboard md-font-size">{t('events-events')} / {this.state.eventInfo.title}</h1>
                                            :
                                            <h1 className="title event-dashboard md-font-size"><Skeleton width={300} /></h1>
                                    }

                                </div>
                            </div>
                            <div className="col-xl-12">
                                <section>
                                    <div className="content-body custom-bg">
                                        {' '}
                                        <div className="row">
                                            <div className="col-12 custom-col">
                                                <div className="col-12">
                                                    <div className="card event-bg">
                                                        {!this.state.imageLoaded && this.state.eventInfo.image && <div className="card-img"><Skeleton height={400} image={true} /></div>}
                                                        {this.state.eventInfo.image && <img onLoad={() => this.setState({ imageLoaded: true })} src={`${this.state.imageUrl}/${this.state.eventInfo.image}`} alt="" className={`card-img${this.state.imageLoaded ? '' : ' d-none'}`} />}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 custom-col">
                                                <div className="col-12 p-0 pt-4 d-flex align-items-start flex-wrap">
                                                    {
                                                        this.state.eventsInfoLoaded ?
                                                            <div className="col-md-8 col-sm-12">
                                                                <div className="event-subtitle xl-font-size" dangerouslySetInnerHTML={{ __html: this.state.eventInfo.content }}></div>
                                                                <div className="news-desc md-font-size" dangerouslySetInnerHTML=
                                                                    {{
                                                                        __html: this.state.eventInfo.desc,
                                                                    }}
                                                                ></div>
                                                            </div>
                                                            :
                                                            <div className="col-md-8 col-sm-12">
                                                                <div className="event-subtitle xl-font-size"><Skeleton /></div>
                                                                <div className="news-desc md-font-size"><Skeleton count={5} /></div>
                                                            </div>
                                                    }
                                                    <div className="col-md-4 col-sm-12">
                                                        <div className="event-speakers-wrapper">
                                                            {
                                                                this.state.eventsInfoLoaded ?
                                                                    <div className="event-date-location xl-font-size">{formatDate(this.state.eventInfo.start)}-{formatDate(this.state.eventInfo.end)} в {this.state.eventInfo.location}</div>
                                                                    :
                                                                    <div className="event-date-location xl-font-size"><Skeleton /></div>
                                                            }
                                                            <div className="event-ul-wrapper md-font-size">
                                                                <span className="event-ul-label">{t('events-speakers')}:</span>
                                                                <ul>
                                                                    {
                                                                        this.state.eventsInfoLoaded ?
                                                                            this.state.eventInfo.data.map((speaker) => (
                                                                                <li key={speaker} className="event-speaker">{speaker};</li>
                                                                            ))
                                                                            :
                                                                            <React.Fragment>
                                                                                <li className="event-speaker"><Skeleton /></li>
                                                                                <li className="event-speaker"><Skeleton /></li>
                                                                                <li className="event-speaker"><Skeleton /></li>
                                                                            </React.Fragment>
                                                                    }
                                                                </ul>
                                                            </div>
                                                            {
                                                                this.state.dataLoaded ?
                                                                    <Button type="button" className="btn profile-avatar-btn event-btn primary" onClick={(event) => this.addToCart(event)}>
                                                                        <Stack size={20} />
                                                                        <span className="pl-5px sm-font-size"> {t('events-booking')}</span>
                                                                    </Button>
                                                                    :
                                                                    <Skeleton className="d-block bg-iherit btn profile-avatar-btn event-btn primary" />
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 custom-col">
                                                <div className="col-12">
                                                    <div className="future-events xl-font-size">{t('events-upcoming')}</div>
                                                    <Row className="future-event-items">
                                                        {
                                                            this.state.eventsLoaded ?
                                                                this.state.events.rows.map((event) => (
                                                                    <EventsMiniCard key={event.id}
                                                                        id={event.id}
                                                                        image={event.image}
                                                                        title={event.title}
                                                                        desc={event.desc}
                                                                        date={event.createdAt}
                                                                        start={event.start}
                                                                        end={event.end}
                                                                        props={this.props}
                                                                    />
                                                                ))
                                                                :
                                                                <React.Fragment>
                                                                    <EventsMiniCard skeleton={true} />
                                                                    <EventsMiniCard skeleton={true} />
                                                                    <EventsMiniCard skeleton={true} />
                                                                </React.Fragment>
                                                        }
                                                    </Row>
                                                </div>
                                            </div>
                                            <div className="col-12 custom-col justify-content-center">
                                                {
                                                    this.state.dataLoaded ?
                                                        <Button type="button" className="btn profile-avatar-btn primary watch-all" onClick={this.routeToEvents}>
                                                            <Stack size={20} />
                                                            <span className="pl-5px sm-font-size"> {t('events-see-all')}</span>
                                                        </Button>
                                                        :
                                                        <Skeleton width={260} button={true} className="btn profile-avatar-btn primary watch-all" />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}

EventDesc.propTypes = {
    match: PropTypes.object,
    i18n: PropTypes.object,
    t: PropTypes.func,
    history: PropTypes.object,
}

export default withTranslation()(EventDesc)


// WEBPACK FOOTER //
// ./src/views/Events/EventDesc.jsx